import React, { useContext } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { BooleanValue, FieldType } from '../data-set/enum';
import Attachment from '../attachment/Attachment';
import { FuncType } from '../button/enum';
import { defaultRenderer } from '../field/utils';
const SimpleCheckBox = function (props) {
    const { checked } = props;
    const { getProPrefixCls } = useContext(ConfigContext);
    const checkBoxPrefix = getProPrefixCls('checkbox');
    return (React.createElement("label", { className: `${checkBoxPrefix}-wrapper ${checkBoxPrefix}-disabled` },
        React.createElement("input", { disabled: true, className: checkBoxPrefix, type: "checkbox", checked: checked }),
        React.createElement("i", { className: `${checkBoxPrefix}-inner` })));
};
SimpleCheckBox.displayName = 'SimpleCheckBox';
export function defaultOutputRenderer(renderOption) {
    const { value, name, record } = renderOption;
    if (record) {
        const field = record.dataSet.getField(name);
        if (field) {
            if (field.get('type', record) === FieldType.boolean) {
                const checked = value === field.get(BooleanValue.trueValue, record);
                return (React.createElement(SimpleCheckBox, { checked: checked }));
            }
            if (field.get('type', record) === FieldType.attachment) {
                return (React.createElement(Attachment, { readOnly: true, name: name, viewMode: "popup", record: record, funcType: FuncType.link }));
            }
        }
    }
    return defaultRenderer(renderOption);
}
